import React from "react";
import { useEquipment } from "../../../../contexts/api";
import type { EquipmentModel } from "../../../../api/equipment/Equipment.typed";

export default function useEquipmentModelsList() {
  const { getEquipmentModels } = useEquipment();
  const [models, setModels] = React.useState<EquipmentModel[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getEquipmentModels()
      .then((res) => {
        if (cancelled) return;
        if (Array.isArray(res)) setModels(res);
        else if (res && "data" in res) setModels(res.data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [getEquipmentModels]);

  return { models, loading };
}
